<template>
    <div class="h-full w-full">
        Construyendo la seccion de: Solicitudes Create
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>